<template>
  <div class="showKnowledge edit-style">
    <!-- {{ searchData }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="goBack" />
      <p class="title">知识点详情</p>
      <!-- <img src="@/assets/learning/setting.png" alt="" @click="toSetting" /> -->
      <span class="subject" @click="showPicker = true">
        {{ timeVal }}
        <van-icon name="arrow-down" size="16" />
      </span>
    </div>
    <div class="header-box">
      <div class="sort-box">
        <div
          v-for="v in sortList"
          :key="v.val"
          class="sort-list"
          :class="{ on: v.click }"
          @click="sortClick(v)"
        >
          {{ v.name }}
        </div>
      </div>
    </div>
    <knowDatil
      v-if="sortList.filter((item) => item.click)[0].val == 2 && keyType"
      :key="key"
      :search-data="searchData"
    ></knowDatil>
    <wrongQuestion
      v-if="sortList.filter((item) => item.click)[0].val == 3 && keyType"
      :key="key"
      :search-data="searchData"
    ></wrongQuestion>
    <!-- 年级弹出层 -->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="timeList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import knowDatil from "@/components/learning/knowDatil";
import wrongQuestion from "@/components/learning/wrongQuestion";
import { subjectOptions, optionsTime } from "@/util/constdata";
import {} from "@/api/interface";
export default {
  name: "ShowKnowledge",
  components: {
    knowDatil,
    wrongQuestion,
  },
  data() {
    return {
      subjectOptions: subjectOptions,
      optionsTime: optionsTime,
      sortList: [
        // { name: "知识点", val: 1, click: false },
        { name: "概况", val: 2, click: false },
        { name: "错题", val: 3, click: false },
      ],
      topVal: [],
      timeList: [],
      timeVal: "",
      subjectVal: "",
      showPicker: false,
      searchData: {
        subjectId: 0,
        timeRange: 0,
        gradeId: 0,
      },
      keyType: false,
      key: 0,
      knowledList: [],
      current: 0,
    };
  },
  // watch: {
  //   timeVal() {
  //     console.log(this.timeVal);
  //   }
  // },
  created() {
    this.sortList[0].click = true;
    // this.init();
  },
  mounted() {
    let type = this.$route.query.isWeb;

    if (type) {
      this.init();
    } else {
      // window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.init();
      this.initMobile();
    }
  },
  methods: {
    goBackView() {
      this.goBack();
      // window.mobile.closeMobileUI();
    },
    initMobile() {
      let u = navigator.userAgent;
      // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    initView(data) {
      Object.assign(this.searchData, data);
      this.$store.commit("setToken", data.token);
      this.$store.commit("setSchoolId", data.schoolID);

      // this.msg = msg;
    },
    goBack() {
      this.$router.go(-1);
    },
    init() {
      Object.assign(this.searchData, this.$route.query);
      this.timeVal = this.optionsTime.filter(
        (item) => item.value == this.searchData.timeRange
      )[0].label;
      this.keyType = true;
      // 初始化时间段
      this.optionsTime.forEach((item) => {
        this.timeList.push(item.label);
      });
    },
    sortClick(v) {
      this.sortList.forEach((i) => {
        i.click = false;
      });
      v.click = true;
    },
    onConfirm(value) {
      this.timeVal = value;
      this.showPicker = false;
      this.searchData.timeRange = this.optionsTime.filter(
        (item) => item.label == this.timeVal
      )[0].value;
      this.key = new Date().getTime();
      // console.log(this.searchData);
      // this.init()
    },
  },
};
</script>

<style scoped lang="scss">
.showKnowledge {
}
</style>
